// @flow
import { Text, View } from 'reshaped';

import type { Prepaid } from '@gandi/billing';
import { useTranslator } from '@gandi/translate';

type Props = {
  prepaid: Prepaid,
  total?: number,
  currency?: string,
};

export function Remaining({
  currency,
  prepaid,
  total,
}: Props): React.MixedElement | null {
  const { __, formatPrice } = useTranslator();

  const { amount } = prepaid;

  if (total === undefined) return null;

  const remaining = total - amount;

  return (
    <View direction="row" justify="space-between">
      <Text as="p" variant="featured-3" weight="bold">
        {__('Remaining')}
      </Text>
      <Text as="p" variant="featured-3" weight="bold">
        {formatPrice(remaining, currency)}
      </Text>
    </View>
  );
}
